import { jsx as p } from "react/jsx-runtime";
import { Tooltip as n, tooltipClasses as a } from "@mui/material";
import { CloseRounded as s } from "@mui/icons-material";
import { styled as i } from "./styled2.mjs";
const l = i(({ className: o, ...t }) => /* @__PURE__ */ p(n, { ...t, classes: { popper: o } }))(({ theme: o }) => ({
  [`& .${a.tooltip}`]: {
    backgroundColor: o.palette.grey[600],
    color: o.palette.grey[50],
    fontSize: o.typography.caption.fontSize,
    fontStyle: o.typography.caption.fontStyle,
    fontWeight: o.typography.caption.fontWeight,
    lineHeight: o.typography.caption.lineHeight
  }
})), d = i("div")(
  ({ $hideTitle: o, theme: t }) => ({
    height: "55px",
    width: "100%",
    display: "flex",
    padding: `${t.spacing(1.75)} ${t.spacing(2)}`,
    justifyContent: o ? "flex-end" : "space-between",
    alignItems: "center",
    gap: t.spacing(1),
    alignSelf: "stretch"
  })
), y = i("div")(({ theme: o }) => ({
  maxHeight: "128px",
  padding: o.spacing(3)
})), f = i("div")(({ theme: o }) => ({
  padding: `${o.spacing(2)} ${o.spacing(3)}`,
  maxHeight: "120px"
})), x = i(s)(({ theme: o }) => ({
  width: o.spacing(3),
  height: o.spacing(3),
  cursor: "pointer",
  color: o.palette.action.active
}));
export {
  x as CloseButton,
  y as Description,
  f as Footer,
  d as Header,
  l as Tooltip
};
//# sourceMappingURL=styles38.mjs.map
